
export class UploadFileData {
    location: string;
    notes: string;
    pped: string;
    recordCount: number;
    totalAmount: number;
    fileType: string;
    emailList: string;
    userId: string;
    userInfo: any;
}
